import React from 'react';
import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import PersistLogin from './components/Auth/PersistLogin';
import RequireAuth from './components/Auth/RequireAuth';
import NotFound from "./components/NotFound";
import Unauthorized from "./components/Unauthorized";
import Layout from './components/Common/Layout';
import MainLayout from './components/Common/MainLayout';
import PublicHome from './components/Public/PublicHome';
import PublicToolSelection from './components/Public/PublicToolSelection';
import PublicHomeSubcategories from './components/Public/PublicHomeSubcategories';
import PublicHomeTools from './components/Public/PublicHomeTools';
import PublicToolsList from './components/Public/PublicToolsList';
import PublicAbout from './components/Public/PublicAbout';
import PublicHelp from './components/Public/PublicHelp';
import PublicResearchPublications from './components/Public/PublicResearchPublications';
import SmartRoute from './components/Auth/SmartRoute';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* Authentication routes - always accessible */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/unauthorized" element={<Unauthorized />} />

                {/* All routes wrapped in PersistLogin to determine auth state */}
                <Route element={<PersistLogin />}>
                    {/* Smart routes - show public version for anonymous, MainLayout for authenticated */}
                    <Route path="/" element={<SmartRoute publicComponent={<PublicHome />} />} />
                    <Route path="/Home" element={<SmartRoute publicComponent={<PublicHome />} />} />
                    <Route path="/Tools/:panelId/:categoryId" element={<SmartRoute publicComponent={<PublicHomeSubcategories />} />} />
                    <Route path="/Tools/:panelId/:categoryId/:subcategoryId" element={<SmartRoute publicComponent={<PublicHomeTools />} />} />
                    <Route path="/ToolSelection" element={<SmartRoute publicComponent={<PublicToolSelection />} />} />
                    <Route path="/ToolsCatalog" element={<SmartRoute publicComponent={<PublicToolsList />} />} />
                    <Route path="/About" element={<SmartRoute publicComponent={<PublicAbout />} />} />
                    <Route path="/Help" element={<SmartRoute publicComponent={<PublicHelp />} />} />
                    <Route path="/ResearchPublications" element={<SmartRoute publicComponent={<PublicResearchPublications />} />} />

                    {/* Protected routes - require authentication */}
                    <Route element={<RequireAuth />}>
                        <Route path="/*" element={<MainLayout />} />
                    </Route>
                </Route>

                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

export default observer(App);
